import { Box } from "@mui/material";
import { CreateButton } from "react-admin";

interface CustomEmptyListProps {
  emptyIcon?: JSX.Element;
  emptyTitle: string;
  emptyListCreateSubtitle: string;
  createButtonText: string;
  hasCreate: boolean;
  createResource?: string;
}

const CustomEmptyList = ({
  emptyIcon,
  emptyTitle,
  emptyListCreateSubtitle,
  createButtonText,
  hasCreate,
  createResource
}: CustomEmptyListProps) => {
  return (
    <div className="w-full h-full flex justify-center items-center">
      <div className="flex flex-col justify-center items-center">
        <Box sx={{ "& path": { fill: "#114B5B" } }}>{emptyIcon}</Box>
        <h4
          className="text-[20px] text-[#114B5B]
          font-['OptimaLTStd'] font-[600] leading-[160%] mt-4"
        >
          {emptyTitle}
        </h4>
        {hasCreate && (
          <p className="text-[14px] text-[#114B5B] font-['Inter'] leading-[143%] mb-4">
            {emptyListCreateSubtitle}
          </p>
        )}
        {hasCreate && (
          <CreateButton
            label={createButtonText}
            resource={createResource}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "36px",
              backgroundColor: "#D9ECF1",
              color: "#114B5B",
              fontSize: "14px",
              lineHeight: "18px",
              fontWeight: 500,
              borderRadius: "18px",
              padding: "0px 16px",
              border: "none",
              textTransform: "none",
              ":hover": {
                backgroundColor: "#D9ECF1"
              }
            }}
          />
        )}
      </div>
    </div>
  );
};

export default CustomEmptyList;
